import { runInAction, makeAutoObservable } from "mobx";
import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants"

import {ErrorWrapper} from "../utils/ErrorWrapper"
import moment from "moment";
  
interface Obj {
  [key: string]: any;
}

class Appointment {
    branchList:Obj[] = [];
    serviceList:Obj[] = [];
    apptDetails:Obj[] = [];
    appointmentList:any[]= [];
    slotsList:Obj[] = [];
  
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true, deep: true });
  }

    getBranchList = ErrorWrapper(async () => {

        const res = await callRemoteMethod({endpoint: CONSTANTS.URL.BRANCH_LIST});
        
        runInAction(()=>{this.branchList=res.result})
    })

    getServiceList = ErrorWrapper(async (branchCode:string) => {

        const res = await callRemoteMethod({endpoint: CONSTANTS.URL.SERVICE_LIST(branchCode)});
        
        runInAction(()=>{this.serviceList=res.result})
    })
    getAppointments = ErrorWrapper(async (data:any) => {
      const {mobile}=data

        const res = await callRemoteMethod({endpoint: CONSTANTS.URL.GET_APPOINTMENTS(mobile)});
        
        // runInAction(()=>{this.appointmentList=res.result})
        const temp = res?.result?.wsGetApptListResp?.apptList?.appt
        this.appointmentList=[]
        for (let i = 0; i < temp?.length; i++) {
          this.appointmentList.push({
            id: i + 1,
            name: temp[i]?.cust?.indCust?.name,
            service: temp[i]?.service?.indService?.serviceName,
            date: moment(temp[i]?.apptDate).format("DD-MM-YYYY"),
            time:  moment(temp[i].apptTime).format("HH:mm"),
            apptcode:  temp[i]?.indAppt?.apptCode,
          })
        }
        runInAction(()=>{this.apptDetails=res?.result?.wsGetApptListResp?.apptList?.appt})
        return res;
    })

    getSlotsList = ErrorWrapper(async ({branchCode, date}:{branchCode:string, date:string}) => {

        const res = await callRemoteMethod({endpoint: CONSTANTS.URL.SLOTS_LIST(branchCode, date)});
        
        runInAction(()=>{this.slotsList=res.result.apptFreeSlot})
        return res.result.apptFreeSlot;
    })

    bookAppointment = ErrorWrapper(async(data:Obj)=>{

        const res = await callRemoteMethod({endpoint: CONSTANTS.URL.BOOK_APPOINTMENT, type: 'POST', data});
        
        // runInAction(()=>{this.premise = {...this.premise, username: res.result.username}})
        return res;
    })
    cancelAppointment = ErrorWrapper(async(data:Obj)=>{

        const res = await callRemoteMethod({endpoint: CONSTANTS.URL.CANCEL_APPOINTMENTS, type: 'POST', data});
        
        // runInAction(()=>{this.premise = {...this.premise, username: res.result.username}})
        return res;
    })
    rescheduleAppointment = ErrorWrapper(async(data:Obj)=>{

        const res = await callRemoteMethod({endpoint: CONSTANTS.URL.RESCHEDULE_APPOINTMENT, type: 'POST', data});
        return res;
        // runInAction(()=>{this.premise = {...this.premise, username: res.result.username}})
    })

}





const appointmentStore = new Appointment()
export default appointmentStore;
